import { workerTask } from './workerTask.js';
/** onResultMessage receives the worker's whole result message, for extras that travel beside the result. */
export function startAnalysis(operation, input, onProgress, onResultMessage) {
  return workerTask(new Worker(new URL('./analysis.worker.js', import.meta.url), { type: 'module' }), { operation, ...input }, onProgress, onResultMessage);
}
